import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cfb9224"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-6 text-gray-600 text-uppercase" }, "Lịch sử phân bổ"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Các lần đổi người phụ trách")
  ])
], -1))
const _hoisted_2 = { class: "card-body pt-5" }
const _hoisted_3 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border spinner-border-sm text-primary" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "text-center text-muted fs-7 py-5"
}
const _hoisted_7 = {
  key: 2,
  class: "timeline-label"
}
const _hoisted_8 = { class: "timeline-label fw-bolder text-gray-800 fs-8 w-75px" }
const _hoisted_9 = { class: "timeline-badge" }
const _hoisted_10 = { class: "timeline-content" }
const _hoisted_11 = { class: "fw-bolder text-gray-800 fs-7" }
const _hoisted_12 = { class: "text-muted fs-8" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "badge badge-light-secondary fs-9 px-1 py-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card card-flush", _ctx.widgetClasses])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : (_ctx.histories.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Chưa có lịch sử thay đổi. "))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.histories, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "timeline-item"
                }, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.formatTime(item.createdAt)), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa fa-genderless fs-1", _ctx.dotClass(item.source)])
                    }, null, 2)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(item.newAssigneeUser?.fullName || 'Unassigned'), 1),
                    _createElementVNode("div", _hoisted_12, [
                      _createTextVNode(" Từ: " + _toDisplayString(item.oldAssigneeUser?.fullName || 'Trống') + " ", 1),
                      _hoisted_13,
                      _createTextVNode(" Nguồn: "),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(item.source), 1)
                    ])
                  ])
                ]))
              }), 128))
            ]))
    ])
  ], 2))
}